module.exports = __WEBPACK_EXTERNAL_MODULE_50__;


//////////////////
// WEBPACK FOOTER
// external {"root":"$","commonjs":"jquery","commonjs2":"jquery","amd":"jquery"}
// module id = 50
// module chunks = 2